<template>
    <form action="">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t('settings.changePasswordTitle') }}</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>
            </header>
            <section class="modal-card-body">
                <!-- <b-field :label="$t('settings.oldPassword')" :label-position="labelPosition">
                    <b-input
                        type="password"
                        v-model="oldPassword"
                        password-reveal
                        :placeholder="$t('settings.oldPasswordPlaceholder')">
                    </b-input>
                </b-field> -->

                <b-field :label="$t('settings.newPassword')" :label-position="labelPosition" 
                    :type="v$.newPassword.$error ? 'is-danger' : ''"
                    :message="v$.newPassword.$error ? v$.newPassword.$errors[0].$message : null">
                    <b-input
                        type="password"
                        v-model="newPassword"
                        password-reveal
                        :placeholder="$t('settings.newPasswordPlaceholder')">
                    </b-input>
                </b-field>

                <b-field :label="$t('settings.newPasswordConfirm')" :label-position="labelPosition" 
                    :type="v$.newPasswordConfirmed.$error ? 'is-danger' : ''"
                    :message="v$.newPasswordConfirmed.$error ? v$.newPasswordConfirmed.$errors[0].$message : null">
                    <b-input
                        type="password"
                        v-model="newPasswordConfirmed"
                        password-reveal
                        :placeholder="$t('settings.newPasswordConfirmPlaceholder')">
                    </b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <div class="buttons">
                    <b-button
                        :label="$t('global.close')"
                        @click="$emit('close')" />
                    <b-button
                        :label="$t('settings.changePassword')"
                        type="is-primary"
                        :disabled="v$?.$error || !v$.newPassword.$dirty || !v$.newPasswordConfirmed.$dirty"
                        @click="changePassword" />
                </div>
            </footer>
        </div>
    </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import KeyCloakService from '@/security/KeycloakService';
import { useVuelidate } from '@vuelidate/core'
import { required, sameAs, minLength, maxLength } from '@/utils/i18n-validators'

export default defineComponent({
    name: 'ChangePassword',
    inject: ['keycloak'],
    setup () {
    return {
      v$: useVuelidate({ $autoDirty: true })
    }
  },
    data() {
        return {
            labelPosition: "inside",
            newPassword: '',
            newPasswordConfirmed: ''
        };
    },
    validations() {
        return {
            newPassword: { required, minLength: minLength(8), maxLength: maxLength(255) },
            newPasswordConfirmed: { sameAs: sameAs(this.newPassword) },
        };
    },
    beforeOpen() {
        this.newPassword = '';
        this.newPasswordConfirmed = '';
    },
    methods: {
        changePassword() {
            fetch('/api/v1/users/password', {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${KeyCloakService.Instance.token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    newPassword: this.newPassword,
                }),
            }).then((response) => {
                if (response.ok) {
                    this.$emit('close');
                    this.$buefy.notification.open({
                        message: this.$t('settings.changePasswordSuccess'),
                        hasIcon: true,
                        iconSize: 'is-medium',
                        type: 'is-success',
                    });
                } else {
                    this.$buefy.notification.open({
                        message: this.$t('settings.changePasswordError'),
                        hasIcon: true,
                        iconSize: 'is-medium',
                        type: 'is-danger',
                    });
                }
            });
        }
    }
});
</script>
